<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M13.31 21a1 1 0 01-.67-.26l-7.31-6.57a1 1 0 111.34-1.48l6.61 5.94 12-11.84a1 1 0 011.4 1.42L14 20.71a1 1 0 01-.69.29z"/></svg>